<template>
  <div class="b-login">
    <div class="b-login__form">
      <div>
        <server-error :error="error" />
        <div class="b-form p-10 pb-15">
          <div class="b-login__title mb-10">
            <h1>{{ $t('CONTENT.Log_in_to') }} Lease Assistant</h1>
          </div>
          <template v-if="isSSO">
            <div class="b-login_type_flex">
              <button
                class="b-btn b-btn_type_primary b-login__submit mt-6"
                type="submit"
                @click="loginThrowSSOAndGetCode"
              >
                {{ $t('CONTENT.Log_in') }}
              </button>
            </div>
          </template>
          <template v-else>
            <div class="b-form__container">
              <label for="loginInput">{{ $t('CONTENT.Login') }}</label>
              <input
                id="loginInput"
                v-model.trim="formData.login"
                type="text"
                class="b-input"
                name="login"
                required
                validationMessage="Login is required"
                autocomplete="off"
              >
            </div>
            <div class="b-form__container mt-5">
              <label for="passwordInput">{{ $t('CONTENT.Password') }}</label>
              <input
                id="passwordInput"
                v-model.trim="formData.password"
                type="password"
                class="b-input"
                name="password"
                required
                validationMessage="Password is required"
                autocomplete="off"
              >
            </div>
            <button
              class="b-btn b-btn_type_primary b-login__submit mt-6"
              type="submit"
              @click="login"
            >
              {{ $t('CONTENT.Log_in') }}
            </button>
          </template>
        </div>
        <div class="b-login_type_flex b-login__app-info">
          {{ this.appInfo }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api/API';
import BaseAPI from '@/api/API';
import DiscountRateAPI from '@/plugins/discountRates/api/DiscountRateAPI';
import AccountAPI from '@/api/AccountAPI';

export default {
  name: 'LoginPage',
  data() {
    return {
      formData: {
        login: null,
        password: null,
      },
      appInfo: null,
      error: null,
    };
  },
  computed: {
    linkToApi() {
      return window.ENV.WEB_API_URL;
    },
    isSSO() {
      return window.ENV.SSO_URL;
    },
    SSObaseUrl() {
      return window.ENV.SSO_URL;
    },
    SSOclientId() {
      return window.ENV.SSO_CLIENT_ID;
    },
    SSOcallbakcUrl() {
      return window.ENV.SSO_CALLBACK_URL;
    },
  },
  async created() {
    this.validateSSO();
    await this.getVersionInfo();
    if (this.$route.path === '/sso-callback') {
      try {
        this.$loadingManager.addLoadingStep(1);
        const { code } = this.$route.query;
        const ssoData = {
          code,
          callbackUrl: this.SSOcallbakcUrl,
          clientId: this.SSOclientId,
          sSOUrlToGetToken: `${this.SSObaseUrl}/token`,
        };

        await this.$store.dispatch('loginSSO', Object.assign({}, ssoData));
        this.$router.push({ name: 'Registry' });
        this.$loadingManager.loadingStepLoaded();
      } catch (e) {
        this.$loadingManager.hideLoadScreen();
        this.error = e;
      }
    } else {
      await this.$store.dispatch('logout');
    }
  },
  methods: {
    validateSSO() {
      if (this.isSSO) {
        console.log(
          'У вас включён режим логина через SSO. Если будут какие-либо проблемы, то убедитесь, что все переменные заданы правильно:',
        );
        console.log(
          'SSO. Базовая ссылка для редиректа в SSO:',
          this.SSObaseUrl,
        );
        console.log('SSO. ИД клиента:', this.SSOclientId);
        console.log('SSO. Callback URL:', this.SSOcallbakcUrl);
        console.log(
          'Если вам нужен другйо способ авторизации, то установите в файле public/env-config.js window.ENV.SSO_URL как null',
        );
      }
    },

    async login() {
      try {
        this.$loadingManager.addLoadingStep(1);
        await this.$store.dispatch('login', Object.assign({}, this.formData));
        const redirectTo = this.$route.query.redirect;
        if (redirectTo) {
          this.$router.push(redirectTo);
        } else {
          this.$router.push('/');
        }
        this.$loadingManager.loadingStepLoaded();
      } catch (e) {
        this.$loadingManager.hideLoadScreen();
        this.error = e;
      }
    },

    loginThrowSSOAndGetCode() {
      const scope = 'openid';
      const repsonseType = 'code';
      const url = `${this.SSObaseUrl}/authorize?client_id=${this.SSOclientId}&scope=${scope}&redirect_uri=${this.SSOcallbakcUrl}&response_type=${repsonseType}`;
      window.location.href = url;
    },
    async getVersionInfo() {
      const api = new AccountAPI();
      const info = await api.getVersionAndCommitHash();
      this.appInfo = `Version: ${info.version} (${info.commitHash})`;
    },
  },
};
</script>
